import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "pagination_contenner container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_pagination = _resolveComponent("el-pagination");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_pagination, {
    background: "",
    size: "small",
    "pager-count": 3,
    layout: "prev, pager, next",
    "prev-text": "Previous Page",
    "next-text": "Next Page",
    "default-page-size": _ctx.pageSize,
    total: _ctx.total,
    "current-page": _ctx.currentPage,
    onCurrentChange: _ctx.handleCurrentChange
  }, null, 8, ["default-page-size", "total", "current-page", "onCurrentChange"])]);
}